/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
//import axios from 'axios'
import Updatepic from '../../../assets/images/update.svg'
import { GET, PUT } from '../../../helpers/httphelper';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { toast as superToast } from 'bulma-toast'


function Update(props) {

    const [fname, setfname] = useState("")
    const [lname, setlname] = useState("")
    const [email, setemail] = useState("")
    const [nic, setnic] = useState("")
    const [birth, setbirth] = useState("")
    const [age, setage] = useState("")
    const [gender, setgender] = useState("")
    const [mobile, setmobile] = useState("")

    const params = useParams()
    const userId = localStorage.getItem("user");

    useEffect(() => {
        getData()
    }, [])

    //get data from profile page
    function getData() {
        GET(`api/user/getuser/${userId}`)
            .then((res) => {
                setfname(res.user.fname)
                setlname(res.user.lname)
                setemail(res.user.email)
                setnic(res.user.nic)
                setbirth(res.user.birth)
                setage(res.user.age)
                setgender(res.user.gender)
                setmobile(res.user.mobile)


            }).catch((err) => {
                console.log(err)
            })
        console.log(params.id)
    }

    //send to updated data to

    function sendData(e) {
        e.preventDefault();

        // if (confpassword === password) {

        // }
        // else {
        //     return (alert("Password Doesn't match"))
        // }
        const newUser = {
            fname,
            lname,
            email: email.toLowerCase(),
            nic,
            birth,
            age,
            gender,
            mobile
        };

        PUT(`api/user/update/${userId}`, newUser)
            .then(() => {
                superToast({
                    message: 'User Updated',
                    type: 'is-success',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
                window.location.href = '/userprofile';


            })
            .catch((err) => {
                console.log(err)
            });
    }

    return (
        <section className="hero is-fullheight-with-navbar">
            <div style={{ padding: '2rem 2rem' }}>
                <div className="container">
                    <div className="columns is-vcentered">
                        <div className="column is-5">
                            <figure className="image">
                                <img src={Updatepic} alt="User Profile" />
                            </figure>
                        </div>
                        <div className="column is-7">
                            <form onSubmit={sendData}>
                                <h1 className='title is-2 has-text-centered'>Update</h1>
                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">First Name</label>
                                            <div className="control">
                                                <input required className="input is-info" type="fname" placeholder='First Name' value={fname} onChange={(e) => { setfname(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Last Name</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='Last Name' value={lname} onChange={(e) => { setlname(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <label className="label">Email</label>
                                            <div className="control">
                                                <input required className="input is-info" type="email" placeholder='Email' value={email} onChange={(e) => { setemail(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <label className="label">NIC</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='NIC' value={nic} onChange={(e) => { setnic(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile  mb-0'>
                                    <div className='column is-5 '>
                                        <div className="field">
                                            <label className="label">Date Of Birth</label>
                                            <div className="control">
                                                <input required className="input is-info" type="date" value={moment(birth).format("YYYY-MM-DD")} onChange={(e) => { setbirth(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Age</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='Age' value={age} onChange={(e) => { setage(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <label className="label">Mobile</label>
                                            <div className="control">
                                                <input className="input is-info" type="tel" placeholder='Mobile number' value={mobile} onChange={(e) => { setmobile(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h1 className='has-text-centered'>
                                    <button type='submit' className='button is-info' > Update </button>
                                </h1>

                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </section>



    )









}
export default Update;

